import { useAuth } from "@/contexts/AuthContext";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useLockBodyScroll } from "@/hooks/useLockBodyScroll";
import { useNavbarState } from "@/hooks/useNavbarState";
import { usePathname } from "@/i18n/navigation";
import { getRouteDetails } from "@/utils/routeHelper";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { memo } from "react";
import NavBar from "./NavBar";

const MenuButton = memo(function MenuButton() {
  const { isLogin, getInitials, loading } = useAuth();
  const isMobile = useIsMobile();
  const navbarState = useNavbarState();
  const pathname = usePathname();

  const { shouldBlurHeader } = getRouteDetails(pathname);

  useLockBodyScroll(!isMobile && navbarState.isOpen);

  const buttonIcon = navbarState.isOpen ? (
    <FontAwesomeIcon
      icon={byPrefixAndName.fak["x-mark-custom"]}
      className="w-6 text-[19px] md:text-[19px]"
    />
  ) : (
    <FontAwesomeIcon
      icon={byPrefixAndName.fak["menu-new"]}
      className="w-6 text-[24px] md:text-[24px]"
    />
  );

  const buttonContent =
    isLogin && !loading ? (
      <>
        <span
          className={clsx(
            "block text-sm font-semibold md:hidden",
            shouldBlurHeader && "text-[13px]! leading-[17px]!",
          )}
        >
          {getInitials()}
        </span>
        <span className="hidden md:block">{buttonIcon}</span>
      </>
    ) : (
      buttonIcon
    );

  const buttonClasses = clsx(
    "flex h-[32px] w-[32px] cursor-pointer items-center justify-center font-medium outline-none md:h-auto md:border-none md:bg-none",
    shouldBlurHeader
      ? "text-primary border border-white bg-white/60 text-black md:bg-white"
      : "bg-primary text-white md:bg-white md:text-black",
    !isLogin && !shouldBlurHeader && "!bg-white !text-black",
    isLogin ? "rounded-full md:rounded-none" : "rounded-lg md:rounded-none",
  );

  return (
    <>
      <div className="order-10 md:order-none">
        <button onClick={navbarState.toggleOpen} className={buttonClasses}>
          {buttonContent}
        </button>
      </div>

      <NavBar {...navbarState} />
    </>
  );
});

export default MenuButton;
